export const DEFAULT_STORE = 'Utrecht';

export const DEFAULT_MAKER_NAME = 'Paul';
